import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../../../environments/environment';
import { Category } from '../../../../core/services/categories/category.model';

@Injectable()
export class CategoryService implements Resolve<any>
{
    routeParams: any;
    category: any;
    onCategoryChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private http: HttpClient
    ) {}

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([
                this.getCategory()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCategory(): Promise<Category|boolean>
    {
        return new Promise((resolve, reject) => {
            if ( this.routeParams.id === 'new' )
            {
                this.onCategoryChanged.next(false);
                resolve(false);
            }
            else
            {
                this.http.get<Category>(`${environment.apiUrl}/categories/${this.routeParams.id}`)
                    .subscribe((response) => {
                        this.category = response;
                        this.onCategoryChanged.next(this.category);
                        resolve(response);
                    }, reject);
            }
        });
    }

    saveCategory(category): Promise<Category>
    {
        return new Promise((resolve, reject) => {
            this.http.put<Category>(`${environment.apiUrl}/categories/${this.routeParams.id}`, category)
                .subscribe((response) => {
                    resolve(response);
                }, reject);
        });
    }

    addCategory(category): Promise<Category>
    {
        return new Promise((resolve, reject) => {
            this.http.post<Category>(`${environment.apiUrl}/categories`, category)
                .subscribe((response) => {
                    resolve(response);
                }, reject);
        });
    }

    postImage(id: string, fileToUpload: File) {
        const endpoint = `${environment.apiUrl}/categories/${id}/image`;
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.http
          .post(endpoint, formData);
    }

    postImageLarge(id: string, fileToUpload: File) {
        const endpoint = `${environment.apiUrl}/categories/${id}/imageLarge`;
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.http
          .post(endpoint, formData);
    }

    deleteImage(categoryId: string) {
        const endpoint = `${environment.apiUrl}/categories/${categoryId}/image`;
        return this.http
            .delete(endpoint);
    }
    deleteImageLarge(categoryId: string) {
        const endpoint = `${environment.apiUrl}/categories/${categoryId}/imageLarge`;
        return this.http
            .delete(endpoint);
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/category/category.service.ts